import type {CreateJobFormData} from '../types';
import '../types';
import {ADMIN_CREATE_JOB_VARIANT_CONFIGS} from '../consts';

const getAtLeastOneVariantDefined = (formValues: CreateJobFormData) => {
	const stringIndexedFormValues = formValues as Record<string, any>;
	return Object.keys(ADMIN_CREATE_JOB_VARIANT_CONFIGS).reduce((acc, val) => {
		if (stringIndexedFormValues[val].version) {
			return true;
		}

		return acc;
	}, false);
};

export default getAtLeastOneVariantDefined;
